import { Routes, Route } from "react-router-dom";
import MainLayout from "../layouts/MainLayout";
import PaymentPage from "../features/Checkout/Payment/pages/PaymentPage";
import SuccessPage from "../features/Checkout/Payment/pages/SuccessPage";
import ContentPolicy from "../features/Content/policy/pages/PolicyPage";
import AboutPage from "../features/Content/about/pages/AboutPage";
import ContactPage from "../features/Content/contact/pages/ContactPage";
import Faq from "../features/Content/faq/pages/FaqPage";
import StyleGuidePage from "../features/Content/guides/styleGuide/pages/StyleGuidePage";
import SizeGuidePage from "../features/Content/guides/sizeGuide/pages/SizeGuidePage";
import HomePage from "../features/Home/pages/HomePage";
import TrackOrderPage from "../features/Content/tracking/pages/TrackOrderPage";
import VideoGalleryPage from "../features/Content/gallery/video/pages/VideoGalleryPage";
import ProductsPage from "../features/Products/listing/pages/ProductsPage";
import FloorMatcher from "../features/Products/floorMatcher/pages/floorMatcherPage";
import CollectionPage from "../features/Collection/pages/CollectionPage";
import ProductDetail from "../features/Products/pdp/pages/ProductDetailPage";
import PromotionsPage from "../features/Products/promotion/pages/PromotionsPage";
import OrderDetailPage from "../features/Account/order/pages/OrderDetailPage";
import OrderTrackingPage from "../features/Account/order/pages/OrderTrackingPage";
import BlogPage from "../features/Content/blog/bloglist/pages/BlogPage";
import BlogPostPage from "../features/Content/blog/blogpost/pages/BlogPostPage";
import CheckoutPage from "../features/Checkout/Summay/pages/CheckoutPage";
import CartPage from "../features/Checkout/Cart/pages/CartPage";
import PaymentCheckPage from "../features/Checkout/Payment/pages/PaymentCheckPage";
import CancelOrderPage from "../features/Account/order/pages/CancelOrderPage";
import ReturnOrderPage from "../features/Account/order/pages/ReturnOrderPage";
import PageNotFound from "../features/Error/PageNotFound";
import AuthLoginPage from "../features/Auth/pages/AuthLoginPage";
import PaymentFailedPage from "../features/Checkout/Payment/pages/PaymentFailedPage";
import PageServerError from "../features/Error/PageServerError";
import OrderHistoryPage from "../features/Account/order/pages/OrderHistoryPage";
import ProfilePage from "../features/Account/profile/pages/ProfilePage";
import AddressPage from "../features/Account/address/pages/AddressPage";
import ReturnSuccessPage from "../features/Account/order/pages/ReturnSuccessPage";
import ExchangeOrderPage from "../features/Account/order/pages/ExchangeOrderPage";
import OffersPage from "../features/Products/offers/pages/OffersPage";

const AppRoutes = () => {
  return (
    // <ScrollToTopWrapper>
    <Routes>
      <Route path="/" element={<MainLayout />}>
        <Route index element={<HomePage />} />
        {/* Collections */}
        <Route path="collections">
          <Route index element={<CollectionPage />} />
          <Route path=":categorySlug" element={<CollectionPage />} />
        </Route>
        {/* Products */}
        <Route path="floor-matcher" element={<FloorMatcher />} />
        <Route path="search" element={<PromotionsPage />} />
        {/* <Route path="products"> */}
        <Route path="/">
          <Route index element={<ProductsPage />} />
          <Route path=":categorySlug" element={<ProductsPage />} />
          <Route path=":categorySlug/:subcategorySlug" element={<ProductsPage />} />
        </Route>
        {/* Product Details */}
        <Route path=":slug/:sku/buy" element={<ProductDetail />} />
        {/* <Route path="productsdetails/:slug" element={<ProductDetail />} /> */}
        {/* Cart & Checkout */}
        <Route path="cart" element={<CartPage />} />
        <Route path="checkout">
          <Route path="init" element={<CheckoutPage />} />
          <Route path="payment/:token" element={<PaymentPage />} />
          {/* Order Status */}
          <Route path=":ref_id/order-confirmed" element={<SuccessPage />} />
          <Route path="order-failed" element={<PaymentFailedPage />} />
        </Route>
        {/* Orders */}
        <Route path="accounts">
          <Route path="orders">
            {/* Orders List */}
            <Route index element={<OrderHistoryPage />} />
            <Route path=":orderNo" element={<OrderDetailPage />} />
            <Route path=":orderNo/cancel" element={<CancelOrderPage />} />
            <Route path=":orderNo/:uuid/return" element={<ReturnOrderPage />} />
            <Route path=":orderNo/:uuid/exchange" element={<ExchangeOrderPage />} />
            {/* Order Tracking */}
            <Route path="order-tracking">
              <Route index element={<OrderTrackingPage />} />
              <Route path=":orderNo" element={<OrderTrackingPage />} />
            </Route>
            {/* Returns & Exchange */}
            <Route path="return-exchange" element={<ExchangeOrderPage />} />
            <Route path="return-success" element={<ReturnSuccessPage />} />
            <Route path="exchange-success" element={<ExchangeOrderPage />} />
            <Route path="cancel-order" element={<CancelOrderPage />} />
          </Route>
          <Route index element={<ProfilePage />} />
          <Route path="addresses" element={<AddressPage />} />
        </Route>
        {/* Auth & Profile */}
        <Route path="login" element={<AuthLoginPage />} />
        {/* Tools */}
        {/* <Route path="search" element={<Searchlist />} /> */}
        {/* Static Pages */}
        <Route path="pages/about-us" element={<AboutPage />} />
        <Route path="contact-us" element={<ContactPage />} />
        <Route path="faq" element={<Faq />} />
        {/** Tracking Related Page */}
        <Route path="track">
          <Route path="shipments" element={<TrackOrderPage />} />
        </Route>
        {/* Blog */}
        <Route path="blog">
          <Route index element={<BlogPage />} />
          <Route path=":blog" element={<BlogPostPage />} />
        </Route>
        {/* Legal */}
        <Route path="policy">
          <Route path=":page_slug" element={<ContentPolicy />} />
        </Route>
        {/* Legal */}
        {/* Marketing Pages */}
        <Route
          path="/shop/:promotionType"
          element={<PromotionsPage />}
        />
        <Route
          path="/special-offers"
          element={<OffersPage />}
        />
        {/* Media */}
        <Route path="reels" element={<VideoGalleryPage />} />
        <Route path="style-guide" element={<StyleGuidePage />} />
        <Route path="size-guide" element={<SizeGuidePage />} />
      </Route>
      {/* Payment Handlers Callbacks */}
      <Route path="payment">
        <Route path="callback" element={<PaymentCheckPage />} />
      </Route>
      <Route path="/error/404" element={<PageNotFound />} />
      <Route path="/error/500" element={<PageServerError />} />
      <Route path="*" element={<PageNotFound />} />
    </Routes >
    // </ScrollToTopWrapper>
  );
};
export default AppRoutes;
